import { createRoute, Outlet } from '@tanstack/react-router';

import { protectedRoute } from '../protected/protected-route';

export const dashboardPlainLayoutRoute = createRoute({
  getParentRoute: () => protectedRoute,
  id: 'dashboard-plain',
  component: () => (
    <div className="bg-brand-light-blue/40">
      <div className="mx-auto min-h-screen max-w-7xl py-24 sm:px-6 sm:py-12 lg:px-8">
        <Outlet />
      </div>
    </div>
  ),
});
